import { W, H, DOOR_W, DOOR_H } from "./world";

const HORIZON = 380;
const FLOOR = 470;
const DOOR_X = 190;
const SUN_X = 730;
export const STRIKE = 108;

const clamp01 = (v) => Math.max(0, Math.min(1, v));
const ease = (k) => k * k * (3 - 2 * k);
const lerp = (a, b, k) => a + (b - a) * k;
const rnd = (i) => ((Math.sin(i * 12.9898) * 43758.5453) % 1 + 1) % 1;
const hex = (h) => [1, 3, 5].map((i) => parseInt(h.slice(i, i + 2), 16));
const mix = (a, b, k) => `rgb(${hex(a).map((v, i) => Math.round(lerp(v, hex(b)[i], k))).join(",")})`;

const STARS = Array.from({ length: 70 }, (_, i) => ({ x: rnd(i) * W, y: rnd(i + 99) * HORIZON * 0.85, s: i % 7 ? 1 : 2 }));

const drawSky = (ctx, t, dawn) => {
  const sky = ctx.createLinearGradient(0, 0, 0, HORIZON);
  sky.addColorStop(0, "#06070b");
  sky.addColorStop(0.6, mix("#0c0e15", "#1b1a20", dawn));
  sky.addColorStop(1, mix("#16151a", "#5c4730", dawn));
  ctx.fillStyle = sky;
  ctx.fillRect(0, 0, W, HORIZON);
  for (const [i, s] of STARS.entries()) {
    ctx.fillStyle = `rgba(220,215,200,${(1 - dawn * 0.7) * (0.3 + 0.25 * Math.sin(t * 0.05 + i))})`;
    ctx.fillRect(s.x, s.y, s.s, s.s);
  }
  const glow = ctx.createRadialGradient(SUN_X, HORIZON, 0, SUN_X, HORIZON, 80 + dawn * 260);
  glow.addColorStop(0, `rgba(235,200,140,${0.15 + dawn * 0.4})`);
  glow.addColorStop(1, "rgba(235,200,140,0)");
  ctx.fillStyle = glow;
  ctx.fillRect(0, 0, W, H);
  ctx.fillStyle = `rgba(240,220,175,${0.25 + dawn * 0.65})`;
  ctx.beginPath();
  ctx.arc(SUN_X, HORIZON + 26 - dawn * 22, 24, 0, Math.PI * 2);
  ctx.fill();
};

const drawGround = (ctx, dawn) => {
  ctx.fillStyle = "#0e0f13";
  ctx.beginPath();
  ctx.ellipse(160, HORIZON + 4, 260, 26, 0, Math.PI, 0);
  ctx.ellipse(880, HORIZON + 6, 200, 18, 0, Math.PI, 0);
  ctx.fill();
  const g = ctx.createLinearGradient(0, HORIZON, 0, H);
  g.addColorStop(0, "#111216");
  g.addColorStop(1, "#07080a");
  ctx.fillStyle = g;
  ctx.fillRect(0, HORIZON, W, H - HORIZON);
  ctx.fillStyle = `rgba(215,190,140,${0.2 + dawn * 0.35})`;
  ctx.fillRect(0, HORIZON, W, 1);
};

const drawDoor = (ctx, t) => {
  const a = 1 - clamp01((t - 150) / 70);
  if (a <= 0) return;
  const top = FLOOR - DOOR_H;
  const close = clamp01((t - 120) / 30);
  ctx.save();
  ctx.globalAlpha = a;
  const pool = ctx.createRadialGradient(DOOR_X + DOOR_W / 2, FLOOR, 0, DOOR_X + DOOR_W / 2, FLOOR, 150);
  pool.addColorStop(0, `rgba(217,207,174,${0.22 * (1 - close)})`);
  pool.addColorStop(1, "rgba(217,207,174,0)");
  ctx.fillStyle = pool;
  ctx.fillRect(DOOR_X - 160, FLOOR - 150, DOOR_W + 320, 220);
  ctx.fillStyle = "#1d2029";
  ctx.fillRect(DOOR_X - 5, top - 5, DOOR_W + 10, DOOR_H + 5);
  ctx.shadowColor = "rgba(230,210,160,0.8)";
  ctx.shadowBlur = 30 * (1 - close);
  ctx.fillStyle = "#d9cfae";
  ctx.fillRect(DOOR_X, top, DOOR_W, DOOR_H);
  ctx.shadowBlur = 0;
  ctx.fillStyle = "#13151c";
  ctx.fillRect(DOOR_X, top, DOOR_W * close, DOOR_H);
  for (let i = 0; i < 18; i++) {
    const y = FLOOR - ((t * 0.7 + rnd(i) * 160) % 160);
    ctx.fillStyle = `rgba(230,210,160,${0.5 * (1 - close) * (y / FLOOR)})`;
    ctx.fillRect(DOOR_X + DOOR_W / 2 + Math.sin(t * 0.03 + i) * 30, y, 2, 2);
  }
  ctx.restore();
};

const runnerPos = (t, strike) => {
  const k = ease(clamp01(((strike ? Math.min(t, STRIKE) : t) - 24) / 185));
  return { x: lerp(DOOR_X + DOOR_W / 2, SUN_X - 34, k), y: lerp(FLOOR, HORIZON + 5, k), s: lerp(1, 0.2, k), k };
};

const drawSkeleton = (ctx) => {
  ctx.fillStyle = "#f2f5ff";
  ctx.fillRect(-12, -34, 24, 34);
  ctx.fillStyle = "#1a1c24";
  ctx.fillRect(-6, -31, 12, 9);
  ctx.fillStyle = "#f2f5ff";
  ctx.fillRect(-4, -28, 3, 3);
  ctx.fillRect(1, -28, 3, 3);
  ctx.fillStyle = "#1a1c24";
  ctx.fillRect(-1, -21, 2, 15);
  for (let i = 0; i < 3; i++) ctx.fillRect(-7, -19 + i * 4, 14, 1.5);
  ctx.fillRect(-6, -6, 4, 6);
  ctx.fillRect(2, -6, 4, 6);
};

const drawCharred = (ctx, d) => {
  ctx.fillStyle = "#6b5f54";
  ctx.fillRect(-13, -35, 26, 35);
  ctx.fillStyle = "#2b2724";
  ctx.fillRect(-12, -34, 24, 34);
  ctx.fillRect(-10, -40, 3, 6);
  ctx.fillRect(-3, -43, 3, 9);
  ctx.fillRect(5, -39, 3, 5);
  ctx.fillStyle = `rgba(255,140,60,${0.5 + 0.5 * Math.sin(d * 0.4)})`;
  ctx.fillRect(-7, -12, 2, 2);
  ctx.fillRect(4, -20, 2, 2);
  ctx.fillRect(-2, -5, 2, 2);
  if (d % 90 < 84) {
    ctx.fillStyle = "#e8e4da";
    ctx.fillRect(2, -27, 3, 3);
    ctx.fillRect(8, -27, 3, 3);
  }
};

const drawSmoke = (ctx, t, fall) => {
  const ox = lerp(0, -22, fall);
  const oy = lerp(-40, -10, fall);
  for (let i = 0; i < 10; i++) {
    const ph = (t * 0.6 + i * 17) % 80;
    const r = 3 + ph * 0.1;
    ctx.fillStyle = `rgba(150,150,150,${(1 - ph / 80) * 0.35})`;
    ctx.beginPath();
    ctx.arc(ox + Math.sin(ph * 0.1 + i) * 6, oy - ph * 0.8, r, 0, Math.PI * 2);
    ctx.fill();
  }
};

const drawRunner = (ctx, g, t, drawPlayer) => {
  const alpha = clamp01((t - 6) / 18);
  if (alpha <= 0) return;
  const strike = g.escape.strike;
  const { x, y, s, k } = runnerPos(t, strike);
  const d = t - STRIKE;
  ctx.save();
  ctx.translate(x, y);
  ctx.scale(s, s);
  if (!strike || d < 0) {
    const jumping = t > 62 && t < 94;
    const hop = jumping ? Math.sin((Math.PI * (t - 62)) / 32) * 30 : 0;
    const p = { x: -12, y: -34 - hop, w: 24, h: 34, vx: k > 0 && !jumping ? 2 : 0, onGround: !jumping, face: 1, squash: jumping ? -0.08 : 0, groundY: 0 };
    drawPlayer(ctx, p, strike ? alpha : alpha * (1 - clamp01((k - 0.85) / 0.15)), g.tick);
  } else {
    ctx.fillStyle = "rgba(0,0,0,0.55)";
    ctx.beginPath();
    ctx.ellipse(0, 0, 34, 7, 0, 0, Math.PI * 2);
    ctx.fill();
    const fall = ease(clamp01((d - 45) / 22));
    ctx.save();
    if (d < 45) ctx.translate(Math.sin(d * 2.3) * 1.5, 0);
    ctx.rotate((-fall * Math.PI) / 2);
    if (d < 16 && d % 4 < 2) drawSkeleton(ctx);
    else drawCharred(ctx, d);
    ctx.restore();
    if (d > 4) drawSmoke(ctx, t, fall);
    if (d < 24) {
      ctx.fillStyle = "#ffe9a8";
      for (let i = 0; i < 10; i++) {
        const a = rnd(i + g.escape.seed) * Math.PI * 2;
        const r = 10 + d * (2 + rnd(i * 3 + g.escape.seed) * 3);
        ctx.fillRect(Math.cos(a) * r, -20 + Math.sin(a) * r, 3, 3);
      }
    }
  }
  ctx.restore();
};

const drawBolt = (ctx, t, seed) => {
  const { x, y, s } = runnerPos(t, true);
  const tx = x;
  const ty = y - 40 * s;
  const sx = tx + (rnd(seed) - 0.5) * 160;
  const pts = [[sx, 0]];
  const n = 14;
  for (let i = 1; i < n; i++) {
    const k = i / n;
    pts.push([lerp(sx, tx, k) + (rnd(seed + i * 7) - 0.5) * 46 * (1 - k * 0.6), lerp(0, ty, k)]);
  }
  pts.push([tx, ty]);
  const stroke = (line, width) => {
    ctx.beginPath();
    ctx.moveTo(line[0][0], line[0][1]);
    for (const [px, py] of line) ctx.lineTo(px, py);
    ctx.lineWidth = width;
    ctx.stroke();
  };
  ctx.save();
  ctx.strokeStyle = "#eef3ff";
  ctx.lineJoin = "miter";
  ctx.shadowColor = "rgba(170,200,255,0.95)";
  ctx.shadowBlur = 24;
  stroke(pts, 4);
  for (let b = 0; b < 3; b++) {
    const from = 2 + Math.floor(rnd(seed + b * 13) * (n - 5));
    const dir = rnd(seed + b * 5) > 0.5 ? 1 : -1;
    const branch = [pts[from]];
    for (let j = 1; j <= 4; j++) {
      const [px, py] = branch[j - 1];
      branch.push([px + dir * (8 + rnd(seed + b * 31 + j) * 18), py + 10 + rnd(seed + b * 17 + j) * 16]);
    }
    stroke(branch, 1.5);
  }
  ctx.shadowBlur = 0;
  ctx.restore();
};

export function renderEscape(ctx, g, drawPlayer) {
  const t = g.escape.t;
  const dawn = ease(clamp01(t / 220));
  const strike = g.escape.strike;
  const d = strike ? t - STRIKE : -100;
  ctx.save();
  if (d >= 0 && d < 20) ctx.translate((Math.random() - 0.5) * 12 * (1 - d / 20), (Math.random() - 0.5) * 8 * (1 - d / 20));
  drawSky(ctx, t, dawn);
  drawGround(ctx, dawn);
  drawDoor(ctx, t);
  drawRunner(ctx, g, t, drawPlayer);
  if ((d >= 0 && d < 9) || (d >= 12 && d < 16)) drawBolt(ctx, t, g.escape.seed + (d >= 12 ? 1 : 0));
  ctx.restore();
  const v = ctx.createRadialGradient(W / 2, H / 2, H * 0.4, W / 2, H / 2, W * 0.7);
  v.addColorStop(0, "rgba(5,6,8,0)");
  v.addColorStop(1, "rgba(5,6,8,0.8)");
  ctx.fillStyle = v;
  ctx.fillRect(0, 0, W, H);
  const flash = d === -4 || d === -2 ? 0.25 : d >= 0 ? Math.max(0, 0.9 - d * 0.06) + (d >= 12 && d < 18 ? 0.45 - (d - 12) * 0.07 : 0) : 0;
  if (flash > 0) {
    ctx.fillStyle = `rgba(235,240,255,${flash})`;
    ctx.fillRect(0, 0, W, H);
  }
}
